import { render, staticRenderFns } from "./krasRelationDocu.vue?vue&type=template&id=4ce84852"
import script from "./krasRelationDocu.vue?vue&type=script&lang=js"
export * from "./krasRelationDocu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce84852')) {
      api.createRecord('4ce84852', component.options)
    } else {
      api.reload('4ce84852', component.options)
    }
    module.hot.accept("./krasRelationDocu.vue?vue&type=template&id=4ce84852", function () {
      api.rerender('4ce84852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/plan/krasRelationDocu.vue"
export default component.exports